import { render, staticRenderFns } from "./InForm8.vue?vue&type=template&id=6849cf8d&scoped=true&"
import script from "./InForm8.vue?vue&type=script&lang=js&"
export * from "./InForm8.vue?vue&type=script&lang=js&"
import style0 from "./InForm8.vue?vue&type=style&index=0&id=6849cf8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6849cf8d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VRow,VSimpleTable})
